import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "success-cases" }
const _hoisted_2 = { class: "cases-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "subtitle" }
const _hoisted_8 = { class: "content" }

import { ref, reactive, onMounted } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import BannerC from '@/components/BannerC.vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'SuccessCases',
  setup(__props) {

const store = useStore()
const casesList: any = ref([])
const router = useRouter()

const toOtherPath = (url: string, pageTitle: any) => {
  router.push(url);
  store.state.pageTitle = [...pageTitle]
}

onMounted(() => {
  selectCommonElement({ columnId: 4 }).then((res: any) => {
    casesList.value = [...res].sort((a: any, b: any) => (a.sortNum ?? 0) - (b.sortNum ?? 0))
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BannerC),
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title-font-style" }, "成功案例", -1)),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(casesList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            onClick: ($event: any) => (toOtherPath(`/case_detail?id=${item.id}&pathName=成功案例,应用案例`, ['成功案例', '应用案例']))
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: item.ossPath
              }, null, 8, _hoisted_4),
              (item.type)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.type), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.subTitle), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.introduction), 1)
            ])
          ], 8, _hoisted_3))
        }), 128))
      ])
    ])
  ]))
}
}

})